import { AxiosResponse } from 'axios'
import { Action } from 'types/redux'
import * as actions from './actions'
import { CreateCommentResponse, DeleteCommentResponse } from './actions'

export type ActionType = 'createComment' | 'deleteComment' | ''

type InitialStateType = {
  response: DeleteCommentResponse | CreateCommentResponse
  action: ActionType

  fetching: boolean
}

const initialState: InitialStateType = {
  response: {
    data: {
      message: '',
    },
    success: false,
    statusCode: 0,
  },
  action: '',
  fetching: false,
}

const getAction = (actionType: string): ActionType => {
  if (actionType === 'CREATE_COMMENT_FULFILLED') return 'createComment'
  if (actionType === 'DELETE_COMMENT_BY_ID_FULFILLED') return 'deleteComment'
  return ''
}

export default function reducer(
  state = initialState,
  action: Action<AxiosResponse<DeleteCommentResponse | CreateCommentResponse>>,
): InitialStateType {
  switch (action.type) {
    case actions.DELETE_COMMENT_BY_ID_PENDING:
    case actions.CREATE_COMMENT_PENDING: {
      return {
        ...state,
        response: {
          ...state.response,
          success: false,
        },
        fetching: true,
      }
    }

    case actions.DELETE_COMMENT_BY_ID_FULFILLED:
    case actions.CREATE_COMMENT_FULFILLED: {
      return {
        ...state,
        // @ts-expect-error -- data is present
        response: { ...action?.payload?.data },
        fetching: false,
        action: getAction(action.type),
      }
    }

    case actions.DELETE_COMMENT_BY_ID_REJECTED:
    case actions.CREATE_COMMENT_REJECTED: {
      // Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching: false,
      }
    }

    default:
      return state
  }
}
